
import { useState, useEffect } from 'react';
import client from '../../contentfulClientToken';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { optimizeContentfulImage } from '../../utils/imageOptimization';
import { INLINES } from "@contentful/rich-text-types";

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default function QuiSuisJe() {
    const [quiSuisJeData, setQuiSuisJeData] = useState(null); // Store the relevant fields



    useEffect(() => {
        const fetchPage = async () => {
            try {
                const response = await client.getEntries({ content_type: 'quiSuisJe' });

                /*     console.log(response); */

                if (response.items.length > 0) {
                    const { albumPhoto01, nomPage, texte, url, titre } = response.items[0].fields;

                    setQuiSuisJeData({ albumPhoto01, nomPage, texte, titre, url }); // Store only relevant fields
                }
            } catch (error) {
                console.error('Error fetching concept data:', error);
            }
        };

        fetchPage();
    }, []);

    // Allow editors to add classes via special hyperlink syntax in Contentful:
    // Select text -> add link with URL like: "span:highlight" or "span:highlight,emphasis"
    // This will render as <span class="highlight emphasis">...</span>
    const allowedSpanClasses = ['highlight', 'emphasis', 'note', 'small'];

    const renderOptions = {
        renderText: text =>
            text.split('\n').reduce((children, textSegment, index) => {
                return [...children, index > 0 && <br key={index} />, textSegment];
            }, []),
        renderNode: {
            [INLINES.HYPERLINK]: (node, children) => {
                const { uri } = node.data;
                // Custom syntax to render a span with classes instead of a link
                if (typeof uri === 'string' && uri.trim().toLowerCase().startsWith('span:')) {
                    const raw = uri.slice(5).trim();
                    // Support comma or space separated list of classes
                    const requested = raw
                        .split(/[,\s]+/)
                        .map((c) => c.trim())
                        .filter(Boolean);
                    // Whitelist classes to avoid injecting arbitrary class names
                    const classes = requested.filter((c) => allowedSpanClasses.includes(c));
                    const className = classes.join(' ') || 'highlight';
                    return <span className={className}>{children}</span>;
                }
                // Fallback to normal hyperlink rendering
                return (
                    <a href={uri} target="_blank" rel="noopener noreferrer">
                        {children}
                    </a>
                );
            },
        },
    };



    if (!quiSuisJeData) {
        return null; // Prevents rendering errors while data is loading
    }

    return (
        <section className="section-quisuisje" data-content-type="quiSuisJe" id="quiSuisJe" data-background-color='#f3dcdc'>

            <div className='inner-container'>


                <div className="phrase">
                    {documentToReactComponents(quiSuisJeData.titre, renderOptions)}
                </div>


                <div className="title">
                    <p>{quiSuisJeData.nomPage}</p>
                </div>

                {quiSuisJeData.albumPhoto01?.fields?.file?.url && (
                    <div className="pictures-container">
                        <img
                            src={optimizeContentfulImage(quiSuisJeData.albumPhoto01.fields.file.url)}
                            alt='Labo Lol'
                        /*    width={quiSuisJeData.albumPhoto01.fields.file.details?.image?.width}
                           height={quiSuisJeData.albumPhoto01.fields.file.details?.image?.height} */
                        />
                    </div>
                )}

                <div className="description">
                    {documentToReactComponents(quiSuisJeData.texte, renderOptions)}
                </div>

            </div>

        </section>
    );
}
